<template>
    <div class="artwork" v-if="item">
        <!-- <audio class="audios" ref="audio" :id="'audio_'+item.ID" v-if="item.acf.sound.url" :src="item.acf.sound.url" preload="auto"></audio> -->
        <!--         <button class="h1 artwork-title" v-if="item.post_title" v-html="item.post_title" @click="playShape(color)" v-bind:class="{active: item == currentArtwork}"></button> -->
        <p class="h1 artwork-title" v-if="item.post_title" v-html="item.post_title" @click="playSound" v-bind:class="{active: item == currentArtwork}" :style="{ color: item.color }"></p>
        <div v-if="item" class="artworks-artists-wrap">
            <span class="h3" v-if="item.acf.caption">{{item.acf.caption}}</span>
            <span class="h3" v-if="item.acf.year">{{item.acf.year.trim()}}</span>
            <span v-for="(artist) in item.acf.artists" :key="artist.ID" class="artworks-artist-wrap h3">
                <router-link :to="{path: '/artists', query: { id: artist.ID }}" class="no-italic">{{artist.post_title.trim()}}</router-link>
            </span>
            <span class="h3" v-if="item.acf.duration">{{item.acf.duration}}</span>
        </div>
        <div class="info" v-if="item.post_content">
            <div>
                <p class="h3" v-if="item.acf.pdf"><a :href="item.acf.pdf.url" target="_blank">PDF</a></p>
                <p class="h3" v-if="item.acf.pdf_for_download"><a :href="item.acf.pdf_for_download.url" target="_blank">BOOKLET TO PRINT</a></p>
            </div>
            <div class="artworks-artists-wrap-button" @click="active = !active">
                <p class="h3" v-if="active">close</p>
                <p class="h3" v-else>info</p>
            </div>
            <div class="artworks-artists-wrap-info" ref="accordion" v-bind:class="{active: active}">
                <div class="language">
                    <div class="col">
                        <div v-html="item.post_content" class="h4 text-justify"></div>
                    </div>
                    <div class="col">
                        <div v-if="item.acf.descrption_en" v-html="item.acf.descrption_en" class="h4 text-justify"></div>
                    </div>
                </div>
            </div>
        </div>
        <audio controls ref="audio" :id="'audio_'+item.ID" v-if="item.acf.sound.url" preload="none" class="audio-player" v-bind:class="{active : player && currentArtwork && currentArtwork.ID == item.ID}" style="">
            <source :src="item.acf.sound.url">Your browser does not support the audio element.
        </audio>
    </div>
</template>
<script>
//https://css-tricks.com/blobs/
//https://stackoverflow.com/questions/30069988/how-can-i-create-a-promise-for-the-end-of-playing-sound
//https://codepen.io/nfj525/pen/rVBaab
//https://codepen.io/EllenProbst/pen/RQQmJK
//https://codepen.io/one20/pen/LGgxQP

import axios from 'axios';
import qs from 'qs';
import * as THREE from 'three';

export default {
    props: ['item', 'status', 'color', 'player'],
    name: 'programme',
    data() {
        return {
            data: null,
            pending: true,
            error: null,
            active: false,
            zIndex: 0,
            analyser: null,
            dataArray: null,
            bufferLength: null,
            audio: null
        }
    },
    components: {},
    computed: {
        currentArtwork() {
            return this.$store.state.currentArtwork;
        },
        soundFrequency() {
            return this.$store.state.soundFrequency;
        }
    },
    mounted() {

    },
    methods: {

        playSound() {
            if (this.item.acf && this.item.acf.sound && this.item.acf.sound.url && this.item.acf.sound.url != "") {
                var sounds = document.getElementsByTagName('audio');
                for (let i = 0; i < sounds.length; i++) {
                    //mettiamo in pausa tutto ma non quello appena cliccato
                    if (document.getElementById('audio_' + this.item.ID)) {
                        if (document.getElementById('audio_' + this.item.ID) != sounds[i]) {
                            sounds[i].pause(sounds[i]);
                            sounds[i].currentTime = 0;
                        }
                    } else {
                        sounds[i].pause(sounds[i]);
                        sounds[i].currentTime = 0;
                    }


                }

                // if (this.currentArtwork) {
                //     document.getElementById('audio_' + this.currentArtwork.ID).pause();
                //     document.getElementById('audio_' + this.currentArtwork.ID).currentTime = 0;
                // }


                if (this.currentArtwork != this.item && this.$refs.audio && this.$refs.audio != "") {
                    // this.$refs.audio.play();

                    // var playPromise = this.$refs.audio.play();
                    let playPromise = document.getElementById('audio_' + this.item.ID).play();

                    if (playPromise !== undefined) {
                        playPromise.then(_ => {
                                // Automatic playback started!
                                // Show playing UI.
                                this.$store.commit('setCurrentArtwork', this.item);
                                this.playShape();
                            })
                            .catch(error => {
                                // Auto-play was prevented
                                // Show paused UI.
                            });
                    }



                } else {
                    let playPromise = document.getElementById('audio_' + this.item.ID);


                    //se è lo stesso che clicco metto in pausa
                    if (playPromise.duration > 0 && !playPromise.paused) {

                        playPromise.pause();
                        let all_canvas = document.querySelectorAll(".main_canvas");
                        all_canvas.forEach(function(item) {})

                        all_canvas.forEach(function(item) {
                            // item.classList.remove("grow");
                            item.classList.add("remove");
                        })


                    }
                    //altrimenti play
                    else {
                        this.playShape();
                        playPromise.play();

                    }
                    // playPromise.currentTime = 0;
                    // this.$store.commit('setCurrentArtwork', null);
                }
            }
        },

        playShape() {

            // let colors = ['#ffff00', '#00ff00', '#00ffff', '#0000ff', '#ff00ff', '#ff0000']
            // var item = colors[Math.floor(Math.random() * colors.length)];
            // let c = "#ffff00"


            let c = this.getRandomColor();
            if (this.item.acf && this.item.acf.sound && this.item.acf.sound.url) {
                if (this.item.acf.sound.url) {
                    this.createBlob(c);
                    // this.playSound();
                    // this.$store.commit('setCurrentArtwork', this.item);
                } else {
                    // this.$store.commit('setCurrentArtwork', null);
                }
            }
            // this.$store.commit('setCurrentArtworkTimestamp', Date.now());

        },
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },

        createBlob(main_color) {
            let all_canvas = document.querySelectorAll(".main_canvas");
            all_canvas.forEach(function(item) {})

            all_canvas.forEach(function(item) {
                // item.classList.remove("grow");
                item.classList.add("remove");
            })


            let self = this;
            let canvas, ctx;
            let render, init;
            let blob;



            class Blob {
                constructor() {
                    this.points = [];
                }

                init() {
                    for (let i = 0; i < this.numPoints; i++) {
                        let point = new Point(this.divisional * (i + 1), this);
                        // point.acceleration = -1 + Math.random() * 2;
                        this.push(point);
                    }
                }

                render() {


                    let canvas = this.canvas;
                    let ctx = this.ctx;
                    let position = this.position;
                    let pointsArray = this.points;
                    let radius = this.radius;
                    let points = this.numPoints;
                    let divisional = this.divisional;
                    let center = this.center;

                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    pointsArray[0].solveWith(pointsArray[points - 1], pointsArray[1]);

                    let p0 = pointsArray[points - 1].position;
                    let p1 = pointsArray[0].position;
                    let _p2 = p1;

                    ctx.beginPath();
                    ctx.moveTo(center.x, center.y);
                    ctx.moveTo((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);

                    for (let i = 1; i < points; i++) {

                        pointsArray[i].solveWith(pointsArray[i - 1], pointsArray[i + 1] || pointsArray[0]);

                        let p2 = pointsArray[i].position;
                        var xc = (p1.x + p2.x) / 2;
                        var yc = (p1.y + p2.y) / 2;
                        ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
                        // ctx.lineTo(p2.x, p2.y);

                        ctx.fillStyle = main_color;
                        // ctx.fillRect(p1.x-2.5, p1.y-2.5, 5, 5);

                        p1 = p2;
                    }

                    xc = (p1.x + _p2.x) / 2;
                    yc = (p1.y + _p2.y) / 2;
                    ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);


                    ctx.fillStyle = main_color
                    ctx.fill();



                    ///PROCSSSORE???

                    // let anima = document.getElementById('animations');
                    // anima.style.transform = `scale( ${ 0.1 + self.soundFrequency/1000})`;
                    requestAnimationFrame(this.render.bind(this));
                }

                push(item) {
                    if (item instanceof Point) {
                        this.points.push(item);
                    }
                }

                set color(value) {
                    this._color = value;
                }
                get color() {
                    return this._color || self.active_color;
                }

                set canvas(value) {
                    if (value instanceof HTMLElement && value.tagName.toLowerCase() === 'canvas') {
                        this._canvas = canvas;
                        this.ctx = this._canvas.getContext('2d');
                    }
                }
                get canvas() {
                    return this._canvas;
                }

                set numPoints(value) {
                    if (value > 2) {
                        this._points = value;
                    }
                }
                get numPoints() {
                    return this._points || 32;
                }

                set radius(value) {
                    if (value > 0) {
                        this._radius = value;
                    }
                }
                get radius() {
                    return this._radius || canvas.width / 4;
                }

                set position(value) {
                    if (typeof value == 'object' && value.x && value.y) {
                        this._position = value;
                    }
                }
                get position() {
                    return this._position || { x: 0.5, y: 0.5 };
                }

                get divisional() {
                    return Math.PI * 2 / this.numPoints;
                }

                get center() {
                    return { x: this.canvas.width * this.position.x, y: this.canvas.height * this.position.y };
                }

                set running(value) {
                    this._running = value === true;
                }
                get running() {
                    return this.running !== false;
                }
            }


            class Point {
                constructor(azimuth, parent) {
                    this.parent = parent;
                    this.azimuth = Math.PI - azimuth;
                    this._components = {
                        x: Math.cos(this.azimuth),
                        y: Math.sin(this.azimuth)
                    };


                    this.acceleration = -0.3 + Math.random() * 0.6;
                }

                solveWith(leftPoint, rightPoint) {
                    this.acceleration = (-0.3 * this.radialEffect + (leftPoint.radialEffect - this.radialEffect) + (rightPoint.radialEffect - this.radialEffect)) * this.elasticity - this.speed * this.friction;
                }

                set acceleration(value) {
                    if (typeof value == 'number') {
                        this._acceleration = value;
                        this.speed += this._acceleration * 2;
                    }
                }
                get acceleration() {
                    return this._acceleration || 0;
                }

                set speed(value) {
                    if (typeof value == 'number') {
                        this._speed = value;
                        this.radialEffect += this._speed * 5;
                    }
                }
                get speed() {
                    return this._speed || 0;
                }

                set radialEffect(value) {
                    if (typeof value == 'number') {
                        this._radialEffect = value;
                    }
                }
                get radialEffect() {
                    return this._radialEffect || 0;
                }

                get position() {
                    return {
                        x: this.parent.center.x + this.components.x * (this.parent.radius + this.radialEffect),
                        y: this.parent.center.y + this.components.y * (this.parent.radius + this.radialEffect)
                    };

                }

                get components() {
                    return this._components;
                }

                set elasticity(value) {
                    if (typeof value === 'number') {
                        this._elasticity = value;
                    }
                }
                get elasticity() {
                    return this._elasticity || 0.001;
                }
                set friction(value) {
                    if (typeof value === 'number') {
                        this._friction = value;
                    }
                }
                get friction() {
                    return this._friction || 0.0085;
                }
            }


            blob = new Blob();

            init = function() {
                // canvas = document.getElementById('canvas');
                canvas = document.createElement('canvas');

                canvas.classList.add('main_canvas');
                // canvas.style.top = Math.floor(Math.random() * screen.width / 2) + "px !important";
                // console.log(Math.floor(Math.random() * screen.width / 2));
                // canvas.style.zIndex = document.querySelectorAll(".main_canvas").length-1;
                let app = document.getElementById('animations');
                // document.body.appendChild(p);
                app.insertBefore(canvas, app.firstChild)
                // self.zIndex = self.zIndex+1;
                console.log(document.querySelectorAll(".main_canvas").length);
                setTimeout(function() {
                    canvas.classList.add('grow');
                }, 1000)



                canvas.setAttribute('touch-action', 'none');

                let resize = function() {
                    canvas.width = window.innerWidth;
                    canvas.height = window.innerHeight;
                };

                window.addEventListener('resize', resize);
                resize();

                let oldMousePoint = { x: 0, y: 0 };
                let hover = false;






                let mouseMove = function(e) {

                    let pos = blob.center;
                    let diff = { x: e.clientX - pos.x, y: e.clientY - pos.y };
                    let dist = Math.sqrt(diff.x * diff.x + diff.y * diff.y);
                    let angle = null;

                    blob.mousePos = { x: pos.x - e.clientX, y: pos.y - e.clientY };

                    if (dist < blob.radius && hover === false) {
                        let vector = { x: e.clientX - pos.x, y: e.clientY - pos.y };
                        angle = Math.atan2(vector.y, vector.x);
                        hover = true;
                        // blob.color = '#77FF00';
                    } else if (dist > blob.radius && hover === true) {
                        let vector = { x: e.clientX - pos.x, y: e.clientY - pos.y };
                        angle = Math.atan2(vector.y, vector.x);
                        hover = false;
                        blob.color = null;
                    }

                    if (typeof angle == 'number') {

                        let nearestPoint = null;
                        let distanceFromPoint = 500;

                        blob.points.forEach(point => {
                            if (Math.abs(angle - point.azimuth) < distanceFromPoint) {
                                // console.log(point.azimuth, angle, distanceFromPoint);
                                nearestPoint = point;
                                distanceFromPoint = Math.abs(angle - point.azimuth);
                            }

                        });

                        if (nearestPoint) {
                            let strength = { x: oldMousePoint.x - e.clientX, y: oldMousePoint.y - e.clientY };
                            strength = Math.sqrt(strength.x * strength.x + strength.y * strength.y) * 10;
                            if (strength > 100) strength = 1000;
                            nearestPoint.acceleration = strength / 1000 * (hover ? -1 : 1);
                        }
                    }


                    // source.connect(analyser);
                    // source.connect(audioCtx.destination);
                    // let data = new Uint8Array(analyser.frequencyBinCount);
                    // requestAnimationFrame(loopingFunction);
                    // analyser.getByteFrequencyData(data); //passing our Uint data array
                    // function loopingFunction() {
                    //     requestAnimationFrame(loopingFunction);
                    //     analyser.getByteFrequencyData(data);
                    //     console.log(data.length);
                    //     // draw(data);
                    // }


                    // https: //medium.com/swlh/building-a-audio-visualizer-with-javascript-324b8d420e7

                    oldMousePoint.x = e.clientX;
                    oldMousePoint.y = e.clientY;
                };
                window.addEventListener('mousemove', mouseMove);
                window.addEventListener('pointermove', mouseMove);




                blob.canvas = canvas;
                blob.init();
                blob.render();
            };

            init();
        }
    },
    watch: {
        currentArtwork(n, o) {},
        active(n, o) {
            let accordion = this.$refs.accordion;
            if (n) {
                accordion.style.height = accordion.scrollHeight + "px";
            } else {
                accordion.style.height = 0;
            }
        }
    }
}
</script>